import { State } from './state';

export class City {
    id: number = 0;
    name: string = '';
    state: State = null;//State.SC;
}